import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../../core/services/auth.service';
import { CartService } from '../../../core/services/cart.service';

@Component({
  selector: 'app-app-header',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  template: `
    <header class="app-header">
      <div class="container header-content">
        <a routerLink="/" class="logo">
          <img src="/logos/logo_final.png" alt="Suntur Quri Wasi" class="logo-img" />
          <span class="logo-text">SUNTUR QURI WASI</span>
        </a>

        <nav class="nav-links" [class.active]="menuOpen">
          <a routerLink="/habitaciones" routerLinkActive="active" class="nav-link">
            <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
              <rect x="2" y="10" width="20" height="8" rx="1" stroke="currentColor" stroke-width="1.5"/>
              <path d="M5 10V8a2 2 0 012-2h10a2 2 0 012 2v2" stroke="currentColor" stroke-width="1.5"/>
            </svg>
            Habitaciones
          </a>
          <a routerLink="/tienda" routerLinkActive="active" class="nav-link">
            <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
              <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4H6z" stroke="currentColor" stroke-width="1.5"/>
              <path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" stroke-width="1.5"/>
            </svg>
            Artesanías
          </a>
          
          <a routerLink="/carrito" routerLinkActive="active" class="nav-link cart-link">
            <div class="cart-icon-wrapper">
              <svg viewBox="0 0 24 24" fill="none" width="20" height="20">
                <circle cx="9" cy="21" r="1" fill="currentColor"/>
                <circle cx="20" cy="21" r="1" fill="currentColor"/>
                <path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              @if (cartItemCount() > 0) {
                <span class="cart-badge">{{ cartItemCount() }}</span>
              }
            </div>
            Carrito
          </a>

          @if (isAuthenticated()) {
            <a routerLink="/mi-cuenta" routerLinkActive="active" class="nav-link">
              <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
                <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="1.5"/>
                <path d="M4 20c0-4 4-6 8-6s8 2 8 6" stroke="currentColor" stroke-width="1.5"/>
              </svg>
              Mi Cuenta
            </a>
            <button class="btn-logout" (click)="logout()">Salir</button>
          }
        </nav>

        <button class="menu-toggle" (click)="toggleMenu()" [attr.aria-expanded]="menuOpen">
          <span class="menu-icon" [class.open]="menuOpen">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>
    </header>
  `,
  styles: [`
    .app-header {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      background: var(--color-white);
      box-shadow: var(--shadow-md);
      z-index: 1000;
      padding: var(--spacing-sm) 0;
    }

    .header-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .logo {
      display: flex;
      align-items: center;
      gap: var(--spacing-sm);
      text-decoration: none;
    }

    .logo-img {
      height: 36px;
      width: auto;
    }

    .logo-text {
      font-family: var(--font-heading);
      font-weight: 700;
      font-size: 1rem;
      letter-spacing: 0.5px;
      color: var(--color-primary);
    }

    .nav-links {
      display: flex;
      align-items: center;
      gap: var(--spacing-md);
    }

    .nav-link {
      display: flex;
      align-items: center;
      gap: var(--spacing-xs);
      text-decoration: none;
      color: var(--color-gray-dark);
      font-family: var(--font-body);
      font-weight: 500;
      font-size: 0.9rem;
      padding: var(--spacing-xs) var(--spacing-sm);
      border-radius: var(--radius-md);
      transition: all var(--transition-fast);

      svg { opacity: 0.7; }

      &:hover, &.active {
        color: var(--color-primary);
        background: rgba(200, 106, 74, 0.08);
        svg { opacity: 1; }
      }
    }

    .cart-link {
      position: relative;
    }

    .cart-icon-wrapper {
      position: relative;
      display: flex;
      align-items: center;
    }

    .cart-badge {
      position: absolute;
      top: -8px;
      right: -8px;
      background: var(--color-primary);
      color: white;
      font-size: 0.7rem;
      font-weight: 700;
      min-width: 18px;
      height: 18px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 4px;
    }

    .btn-login {
      background: var(--color-primary);
      color: var(--color-white) !important;
      padding: var(--spacing-xs) var(--spacing-md);
      border-radius: var(--radius-md);
      text-decoration: none;
      font-weight: 600;
      font-size: 0.9rem;
      transition: all var(--transition-fast);

      &:hover {
        background: var(--color-primary-dark);
        transform: translateY(-1px);
      }
    }

    .btn-logout {
      background: transparent;
      border: 1px solid var(--color-gray);
      color: var(--color-gray-dark);
      padding: var(--spacing-xs) var(--spacing-md);
      border-radius: var(--radius-md);
      cursor: pointer;
      font-family: var(--font-body);
      font-weight: 500;
      font-size: 0.9rem;
      transition: all var(--transition-fast);

      &:hover {
        border-color: var(--color-primary);
        color: var(--color-primary);
      }
    }

    .menu-toggle {
      display: none;
      background: transparent;
      border: none;
      cursor: pointer;
      padding: var(--spacing-xs);
    }

    .menu-icon {
      display: flex;
      flex-direction: column;
      gap: 5px;
      width: 24px;

      span {
        display: block;
        height: 2px;
        background: var(--color-primary);
        border-radius: 2px;
        transition: all var(--transition-fast);
      }

      &.open span:nth-child(1) { transform: rotate(45deg) translate(5px, 5px); }
      &.open span:nth-child(2) { opacity: 0; }
      &.open span:nth-child(3) { transform: rotate(-45deg) translate(5px, -5px); }
    }

    @media (max-width: 992px) {
      .menu-toggle { display: block; }

      .nav-links {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        flex-direction: column;
        background: var(--color-white);
        padding: var(--spacing-lg);
        box-shadow: var(--shadow-lg);
        display: none;
        gap: var(--spacing-sm);

        &.active { display: flex; }

        .nav-link {
          width: 100%;
          justify-content: center;
          padding: var(--spacing-sm);
        }

        .btn-login, .btn-logout {
          width: 100%;
          text-align: center;
        }
      }
    }
  `]
})
export class AppHeaderComponent {
  private authService = inject(AuthService);
  private cartService = inject(CartService);

  menuOpen = false;

  isAuthenticated = this.authService.isAuthenticated;
  cartItemCount = this.cartService.itemCount;

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  logout(): void {
    this.authService.logout();
    this.menuOpen = false;
  }
}
